'use client'

import {
  __closeSelectFavoritePointOfSaleDrawerAtom,
  __isSelectFavoritePointOfSaleDrawerOpenAtom,
  __selectFavoritePointOfSaleDrawerAtom,
} from '@/feature/point-of-sale/services/pointOfSale.store'
import { useRefreshUserTrackingData } from '@/lib/tracking/hooks/usePageTracking.client'
import { gql } from '@gql-generated/gql'
import { useAtomValue, useSetAtom } from 'jotai'
import { memo, useEffect, useState } from 'react'
import { switchPickupPointOfSale } from '../../../services/pointOfSale.action'
import { SelectablePointOfSaleCard } from '../../selectable-point-of-sale-card/SelectablePointOfSaleCard.client'
import SelectPointOfSaleDrawer_V2 from '../_components/SelectPointsOfSaleDrawer.client'
import { useLazyQuery } from '@apollo/client'
import { SelectFavoritePointOfSaleDrawerDocument } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  query SelectFavoritePointOfSaleDrawer($searchPostalCode: String) {
    currentUser {
      availablePointsOfSale(searchPostalCode: $searchPostalCode) {
        ...SelectablePointOfSaleCard_V2_pointOfSale
      }
    }
  }
`)

export const SelectFavoritePointOfSaleDrawer = memo(function SelectFavoritePointOfSaleDrawer() {
  const { selectedId, isOpen } = useAtomValue(__selectFavoritePointOfSaleDrawerAtom)

  const closeDrawer = useSetAtom(__closeSelectFavoritePointOfSaleDrawerAtom)
  const refreshUserTracking = useRefreshUserTrackingData()

  const [searchPostalCode, setSearchPostalCode] = useState<string>('')

  const [loadPointsOfSale, { data, loading, error }] = useLazyQuery(
    SelectFavoritePointOfSaleDrawerDocument,
  )

  /**
   * Load the points of sale when opening the drawer
   */
  useEffect(() => {
    if (!isOpen) return
    loadPointsOfSale({ variables: { searchPostalCode } })
  }, [isOpen, loadPointsOfSale, searchPostalCode])

  return (
    <SelectPointOfSaleDrawer_V2
      isOpenAtom={__isSelectFavoritePointOfSaleDrawerOpenAtom}
      pointsOfSale={data?.currentUser?.availablePointsOfSale}
      isLoading={loading}
      error={error}
      searchPostalCode={searchPostalCode}
      onSearchPostalCodeChangeAction={setSearchPostalCode}
      renderPointOfSale={(pos) => (
        <SelectablePointOfSaleCard
          isSelected={selectedId === pos.id}
          displayStock={false}
          pointOfSale={pos}
          onPointOfSaleSelected={async (pos) => {
            await switchPickupPointOfSale(pos.id, { setAsFavoriteToo: true })
            closeDrawer(pos.id)
            refreshUserTracking()
          }}
        />
      )}
    />
  )
})
